<template>
    <div class="fd-banner">
        <div class='fd-banner-home'>
            <div class="fd-banner-content">
                
                
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "banner",
    data() {
        return {
            // 当前页面是否是首页
            // isHome: true,

        };
    },
    created() {
    },

    methods: {
    }
};
</script>
<style lang="less">
.fd-banner {
    .fd-banner-home {
        width: 100%;
        height: 348px;
        background: #fff url("../../images/home/banner.png") no-repeat center;

        .fd-banner-content {
            width: 1200px;
            margin: 0 auto;
            // padding-top: 201px;
            // position: relative;

        }
    }

    
}</style>


// WEBPACK FOOTER //
// src/components/common/banner.vue